<template>
  <SecondaryModal
    name="delete-matrix-messages"
    :title="$t('chat.deleteMessages.title')"
    @before-open="reset"
    v-if="chat"
  >
    <div v-html="$t('chat.deleteMessages.confirmation', { n: pickedCount })"></div>

    <template v-slot:footer>
      <BaseButton oval secondary @click="$modal.hide('delete-matrix-messages')">
        {{ $t('buttonCancel') }}
      </BaseButton>
      <BaseButton
        oval
        :loading="loading"
        :disabled="isDisabled"
        @click="deleteRequest">
        {{ $t('buttonDelete') }}
      </BaseButton>
    </template>
  </SecondaryModal>
</template>

<script>
import SecondaryModal from './SecondaryModal'
import { mapGetters, mapActions } from 'vuex'
import { parseRouterQueryParam } from '@/helpers/index'

export default {
  name: 'delete-matrix-messages-popup',
  components: {
    SecondaryModal
  },
  props: {
    message: {
      type: Array,
      default: () => ([])
    },
    onDeleted: {
      type: Function,
      default: () => function () {}
    },
    beforeDelete: {
      type: Function,
      default: () => function () {}
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      messageById: 'entities/messages/getById',
      chatById: 'entities/chats/getById'
    }),
    pickedCount () {
      return this.message.length
    },
    messages () {
      return this.message
    },
    chat () {
      if (!this.pickedCount) return
      return this.messages[0]
    },
    isDisabled () {
      return !this.message || !this.message.length
    }
  },
  methods: {
    ...mapActions({
      deleteMessages: 'entities/messages/remove'
    }),
    reset () {
      this.loading = false
    },
    async deleteRequest () {
      if (this.isDisabled) return
      this.loading = true
      this.beforeDelete()
      await window.matrixSDK.redactEvent(parseRouterQueryParam(this.$route.query.id, true), this.message[0].event_id, '')
      this.loading = false
      this.$modal.hide('delete-messages')
      this.onDeleted()
    }
  }
}
</script>

<style module lang="scss">
.checkWrap {
  margin-top: 8px;
  display: inline-block;
}
</style>
